export default __webpack_public_path__ + "9c506c19aaf15a5d83720b8c7b2bfbfd.svg";